import React from 'react';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { weekDays } from '../../constant';
import { getTeamMoodData, postTeamMoodData, updateTeamMoodData } from '../../service/adminApi';
import Loader from '../../StaticComponent/Loader';
import { getNextWeekday, getTimestampToDate } from '../../utils/dateConvetor';
import './teammembermood.css';

function TeamMood() {
    let teamData = {
        reccurence_options: 'weekly',
        start_date: '',
        end_date: '',
        weekday: '',
        id: '',
    };

    let breadCrumbsData = [
        { title: 'Dashboard', isActive: true, path: '/Overview' },
        { title: 'Admin', isActive: true, path: '/admin/accountbranding' },
        { title: 'Team Member Mood', isActive: true, path: '' },
        { title: 'Recurrence', isActive: false, path: '' },
    ];

    const [teamMoodDetails, setTeamMoodDetails] = React.useState(teamData);
    const [weekday, setWeekday] = React.useState('');
    const [nextDate, setNextDate] = React.useState();
    const [weekNum, setWeekNum] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        getTeamMoodDetails();
    }, []);

    React.useEffect(() => {
        if (teamMoodDetails.start_date !== undefined && teamMoodDetails.weekday !== undefined) {
            const nextDay = getNextWeekday(teamMoodDetails.start_date, teamMoodDetails.weekday);
            setNextDate(nextDay);
        }
    }, [teamMoodDetails]);

    const getTeamMoodDetails = async () => {
      
        const response = await getTeamMoodData();
        if (response.data.data.length > 0) {
            let { reccurence_options, start_date, end_date, weekday, id } = response.data.data[0];
            start_date = getTimestampToDate(start_date, 2);
            end_date = getTimestampToDate(end_date, 2);
            setTeamMoodDetails({
                reccurence_options,
                start_date,
                end_date,
                weekday,
                id,
            });
            setWeekday(weekDays[weekday]);
            setWeekNum(weekday);
            setLoading(true);
        }
        setLoading(true);
    };

    const handleTeamMoodData = (e) => {
        if (e.target.name === 'weekday') {
            setWeekday(weekDays[e.target.value]);
            setWeekNum(e.target.value);
        }

        setTeamMoodDetails((teamMoodDetails) => ({
            ...teamMoodDetails,
            [e.target.name]: e.target.value,
        }));
    };

    const postTeamMood = async () => {
        let response;
        if (teamMoodDetails.id === '') {
            response = await postTeamMoodData(teamMoodDetails);
        } else {
            response = await updateTeamMoodData(teamMoodDetails);
        }
        if (response.data.data.length > 0) {
            let { reccurence_options, start_date, end_date, weekday, id } = response.data.data;
            setTeamMoodDetails({
                reccurence_options,
                start_date,
                end_date,
                weekday,
                id,
            });
        }
    };

    return (
        <div className="col-md-10 offset-md-2 content-card">
            <BreadCrumbs data={breadCrumbsData} />
            <div className="admin-panel-bg p-3 mb-4">
                <div className="row">
                    <div className="col-md-6">
                        <h5 className="bold-text tt-bold font-18">Team Members Mood - Recurrence</h5>
                        <p className="font-13 regular-text font-grey mb-3">
                            Team members mood helps to know the mood of the employees in the current week.
                        </p>
                        <div className="row">
                            {/* <div class="col-md-7"> */}
                            <label className="font-13 semibold-text my-3 mood-label-color">Recurrence</label>
                            <div className="d-flex mb-3">
                                <input
                                    type="radio"
                                    className="me-2 mt-0 form-check-input admin-mood-custom-radio-btn"
                                    id="feedback"
                                    disabled
                                    name="concern"
                                />
                                <label className="font-12 semibold-text me-3 form-check-label" htmlFor="feedback">
                                    Daily
                                </label>
                                <input
                                    type="radio"
                                    className="me-2 mt-0 form-check-input admin-mood-custom-radio-btn"
                                    id="lead_manager"
                                    name="concern"
                                    defaultChecked
                                />
                                <label className="font-12 semibold-text me-3 form-check-label" htmlFor="lead_manager">
                                    Weekly
                                </label>
                            </div>
                            <label className="font-13 semibold-text mt-3">Start</label>
                            <div className="col-md-3 mb-4">
                                <input
                                    type="date"
                                    name="start_date"
                                    value={teamMoodDetails.start_date}
                                    onChange={handleTeamMoodData}
                                    className="custom-textfield medium-text custom-input-background  font-12 mt-2 form-control"
                                />
                            </div>
                            <label className="font-13 semibold-text my-3 mood-label-color">On</label>
                            <div className="d-flex mb-5">
                                <button
                                    value="0"
                                    type="button"
                                    name="weekday"
                                    className={`btn ${weekNum == 0 ? ' weekend-selected' : 'admin-circular-btn'} tt-bold me-3`}
                                    onClick={handleTeamMoodData}
                                >
                                    S
                                </button>
                                <button
                                    name="weekday"
                                    type="button"
                                    onClick={handleTeamMoodData}
                                    value="1"
                                    className={`btn ${weekNum == 1 ? ' weekend-selected' : 'admin-circular-btn'}  tt-bold me-3`}
                                >
                                    M
                                </button>
                                <button
                                    value="2"
                                    name="weekday"
                                    type="button"
                                    onClick={handleTeamMoodData}
                                    className={`btn ${weekNum == 2 ? ' weekend-selected' : 'admin-circular-btn'}  tt-bold me-3`}
                                >
                                    T
                                </button>
                                <button
                                    value="3"
                                    type="button"
                                    name="weekday"
                                    onClick={handleTeamMoodData}
                                    className={`btn ${weekNum == 3 ? ' weekend-selected' : 'admin-circular-btn'}  tt-bold me-3`}
                                >
                                    W
                                </button>
                                <button
                                    value="4"
                                    type="button"
                                    name="weekday"
                                    onClick={handleTeamMoodData}
                                    className={`btn ${weekNum == 4 ? ' weekend-selected' : 'admin-circular-btn'}  tt-bold me-3`}
                                >
                                    T
                                </button>
                                <button
                                    value="5"
                                    type="button"
                                    name="weekday"
                                    onClick={handleTeamMoodData}
                                    className={`btn ${weekNum == 5 ? ' weekend-selected' : 'admin-circular-btn'} tt-bold me-3`}
                                >
                                    F
                                </button>
                                <button
                                    value="6"
                                    type="button"
                                    name="weekday"
                                    onClick={handleTeamMoodData}
                                    className={`btn ${weekNum == 6 ? ' weekend-selected' : 'admin-circular-btn'} tt-bold me-3`}
                                >
                                    S
                                </button>
                            </div>
                            <label className="font-13 semibold-text  mood-label-color">End</label>
                            <div className="col-md-3">
                                <input
                                    type="date"
                                    name="end_date"
                                    value={teamMoodDetails.end_date}
                                    min={teamMoodDetails.start_date}
                                    onChange={handleTeamMoodData}
                                    className="custom-textfield custom-input-background  medium-text font-12 mt-2 form-control"
                                />
                            </div>
                            <p className="font-14 regular-text mt-2" style={{ margin: '0px' }}>
                                Occurs <span className="text-dark bold-text">every {weekday}</span> starting {weekday},{' '}
                            </p>
                            <p className="font-14 regular-text">{nextDate}.</p>
                            <p />
                            <div className="d-flex justify-content-end m-3">
                                <button className="btn hive-btn-secondary me-3" onClick={() => getTeamMoodDetails()}>
                                    Cancel
                                </button>
                                <button onClick={() => postTeamMood()} className="btn hive-btn-primary">
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Loader isLoading={loading} />
        </div>
    );
}

export default TeamMood;
